/**
 * National Profile Extended Questionnaires (BSI_DE, ANSSI_FR, KSBP_LT, NCA_EE)
 * Minimal SELF_ASSESSMENT blocks - cross-mapped to ISO27001
 */
import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';

export const BSI_DE_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'bsi-org',
    name_en: 'Organizational Structure (IT-Grundschutz)',
    name_es: 'Estructura organizativa',
    name_ru: 'Организационная структура',
    questions: [
      { id: 'bsi_org_1', blockId: 'bsi-org', text_en: 'Is there a defined ISMS?', text_es: '¿Existe un ISMS definido?', text_ru: 'Определена ли система управления ИБ (ISMS)?' },
      { id: 'bsi_org_2', blockId: 'bsi-org', text_en: 'Are security roles and responsibilities assigned?', text_es: '¿Roles y responsabilidades asignados?', text_ru: 'Назначены ли роли и обязанности по безопасности?' },
      { id: 'bsi_org_3', blockId: 'bsi-org', text_en: 'Are security policies documented and approved?', text_es: '¿Políticas documentadas y aprobadas?', text_ru: 'Документированы и утверждены ли политики?' },
      { id: 'bsi_org_4', blockId: 'bsi-org', text_en: 'Is risk assessment performed regularly?', text_es: '¿Evaluación de riesgos realizada?', text_ru: 'Регулярно ли проводится оценка рисков?' },
      { id: 'bsi_org_5', blockId: 'bsi-org', text_en: 'Is incident management implemented?', text_es: '¿Gestión de incidentes implementada?', text_ru: 'Реализовано ли управление инцидентами?' },
    ],
  },
];

export const ANSSI_FR_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'anssi-gov',
    name_en: 'ANSSI Governance & Security',
    name_es: 'Gobernanza ANSSI',
    name_ru: 'Управление ANSSI',
    questions: [
      { id: 'anssi_1', blockId: 'anssi-gov', text_en: 'Is security governance defined?', text_es: '¿Gobernanza de seguridad definida?', text_ru: 'Определено ли управление безопасностью?' },
      { id: 'anssi_2', blockId: 'anssi-gov', text_en: 'Are critical systems identified and protected?', text_es: '¿Sistemas críticos identificados y protegidos?', text_ru: 'Идентифицированы и защищены ли критичные системы?' },
      { id: 'anssi_3', blockId: 'anssi-gov', text_en: 'Is incident reporting to ANSSI defined?', text_es: '¿Reporte de incidentes a ANSSI definido?', text_ru: 'Определён ли порядок сообщения об инцидентах в ANSSI?' },
      { id: 'anssi_4', blockId: 'anssi-gov', text_en: 'Are security measures documented?', text_es: '¿Medidas de seguridad documentadas?', text_ru: 'Документированы ли меры безопасности?' },
    ],
  },
];

export const KSBP_LT_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'ksbp-gov',
    name_en: 'KSBP (Lithuania) Governance',
    name_es: 'Gobernanza KSBP',
    name_ru: 'Управление KSBP (Литва)',
    questions: [
      { id: 'ksbp_1', blockId: 'ksbp-gov', text_en: 'Is cybersecurity governance in place?', text_es: '¿Gobernanza de ciberseguridad en marcha?', text_ru: 'Организовано ли управление кибербезопасностью?' },
      { id: 'ksbp_2', blockId: 'ksbp-gov', text_en: 'Are essential services identified?', text_es: '¿Servicios esenciales identificados?', text_ru: 'Идентифицированы ли основные услуги?' },
      { id: 'ksbp_3', blockId: 'ksbp-gov', text_en: 'Is incident notification to NRA defined?', text_es: '¿Notificación de incidentes definida?', text_ru: 'Определён ли порядок уведомления NRA?' },
    ],
  },
];

export const NCA_EE_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'nca-gov',
    name_en: 'NCA (Estonia) Governance',
    name_es: 'Gobernanza NCA',
    name_ru: 'Управление NCA (Эстония)',
    questions: [
      { id: 'nca_1', blockId: 'nca-gov', text_en: 'Is cybersecurity management implemented?', text_es: '¿Gestión de ciberseguridad implementada?', text_ru: 'Реализовано ли управление кибербезопасностью?' },
      { id: 'nca_2', blockId: 'nca-gov', text_en: 'Are critical infrastructures protected?', text_es: '¿Infraestructuras críticas protegidas?', text_ru: 'Защищена ли критическая инфраструктура?' },
      { id: 'nca_3', blockId: 'nca-gov', text_en: 'Is incident reporting to NCA defined?', text_es: '¿Reporte a NCA definido?', text_ru: 'Определён ли порядок отчётности в NCA?' },
    ],
  },
];
